var CurrentUser = require("lib/account/CurrentUser");
var Glyphicon = require("components/utility/icons/Glyphicon");
var Spinner = require("components/utility/Spinner");
var LoadingButton = require("components/utility/LoadingButton");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var DocumentClient = require("lib/web/DocumentClient");
var CustomerIOClient = require("lib/integrations/CustomerIOClient");

var AddNewClassModal = require("components/org/roster/AddNewClassModal");
var AddNewStudentModal = require("components/org/roster/AddNewStudentModal");

import moment from 'moment';
import { Link } from "react-router-dom";

require("appdev/wizards/user_details_page.scss");

class UserDetailsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { user: null, editingFields: { prefs: {}, premium_account: {} }, editedInformation: { prefs: {}, premium_account: {} }, loading: false, showArchiveListStudents: false, adminsLoading: [] }
	}

	toggleEdit(attribute) {
		var updatedEditingFields = _.clone(this.state.editingFields);
		if (PREF_ATTRIBUTES.includes(attribute)) {
			updatedEditingFields['prefs'][attribute] = !this.state.editingFields['prefs'][attribute];
		} else if (PREMIUM_ACCOUNT_ATTRIBUTES.includes(attribute)) {
			updatedEditingFields['premium_account'][attribute] = !this.state.editingFields['premium_account'][attribute];
		} else {
			updatedEditingFields[attribute] = !this.state.editingFields[attribute];
		}
		this.setState({ editingFields: updatedEditingFields });
	}
	// submit if enter key is pressed
	onEditKeyPress(attribute, event) {
		if (event.keyCode == 13) {
			this.submitAndToggle(attribute);
		}
	}
	submitAndToggle(attribute) {
		if (PREF_ATTRIBUTES.includes(attribute)) {
			this.submitEditedSettingsInformation(attribute, 'prefs', 'update_prefs');
		} else if (PREMIUM_ACCOUNT_ATTRIBUTES.includes(attribute)) {
			this.submitEditedSettingsInformation(attribute, 'premium_account', 'update_premium_account');
		} else {
			this.submitEditedInformation(attribute);
		}
		this.toggleEdit(attribute);
	}
	updateEditedInformation(attribute, event = null, callback = null) {
		var updatedInformation = _.clone(this.state.editedInformation);
		updatedInformation[attribute] = event ? event.target.value : null;
		this.setState({ editedInformation: updatedInformation }, () => {
			if (callback) { callback(); }
		});
	}
	// pref need to be updated separately
	updateEditedPrefsInformation(attribute, type, event = null, callback = null) {
		var updatedInformation = _.clone(this.state.editedInformation);
		updatedInformation[type][attribute] = event ? event.target.value : null;
		this.setState({ editedInformation: updatedInformation }, () => {
			if (callback) { callback(); }
		});
	}
	triggerUserAction(attribute) {
		var hackyHash = { target: { value: true } };
		this.updateEditedInformation(attribute, hackyHash, () => {
			this.submitEditedInformation(attribute);
		});
	}
	submitEditedInformation(attribute) {
		var updatedValue = this.state.editedInformation[attribute];

		if (updatedValue != null) {
			this.setState({ loading: true });

			var attributeHash = {};
			attributeHash[attribute] = updatedValue;

			var user = this.state.user;
			var params = { effective_user_id: user.id };

			if (user.is_student) {
				var patchUserF = CurrentUser.api().patchStudent;
				var userType = "student";
			} else {
				var patchUserF = CurrentUser.api().patchAdmin;
				var userType = "admin";
			}
			params[userType] = attributeHash;

			patchUserF(user.id, params, $wr.apiHandler((response) => {
				this.setState({ loading: false });
				if (response[userType].errors) {
					this.toggleEdit(attribute);
					window.wrNotifications.triggerDropDownNotification({
						title: "Sorry!", text: response[userType].errors.join(", "), 
						icon: "exclamation-sign", type: "error" });
				} else {
					setTimeout(function() {
						window.wrNotifications.triggerDropDownNotification({
							title: "Information Edited", icon: "ok-sign" });
						}.bind(this), 1000);

					this.fetchUserDetails();
				}
			}));
		}
	}
	// pref changes need to be submitted in a different format
	submitEditedSettingsInformation(attribute, type, teacher_action) {
		var updatedValue = this.state.editedInformation[type];

		if (updatedValue != null) {
			this.setState({ loading: true });

			var user = this.state.user;
			var params = { effective_user_id: user.id };
			params[`${type}`] = updatedValue;
			params['teacher_action'] = teacher_action;

			CurrentUser.api().patchAdmin(user.id, params, $wr.apiHandler((response) => {
				this.setState({ loading: false });
				if (response['admin'].errors) {
					this.toggleEdit(attribute);
					window.wrNotifications.triggerDropDownNotification({
						title: "Sorry!", text: response['admin'].errors.join(", "),
						icon: "exclamation-sign", type: "error"
					});
				} else {
					setTimeout(function () {
						window.wrNotifications.triggerDropDownNotification({
							title: "Information Edited", icon: "ok-sign"
						});
					}.bind(this), 1000);

					this.fetchUserDetails();
				}
			}));
		}
	}

	submitExtensionRequest(feature, event) {
		// var updatedValue = this.state.editedInformation[attribute];
		var value = this.refs[feature].value
		if (value != null) {
			this.setState({ loading: true });

			var attributeHash = {};
			attributeHash["feature"] = feature;
			attributeHash["days"] = value;

			var user = this.state.user;
			var params = { effective_user_id: user.id };

			if (user.is_student) {
				var patchUserF = CurrentUser.api().patchStudent;
				var userType = "student";
			} else {
				var patchUserF = CurrentUser.api().patchAdmin;
				var userType = "admin";
			}
			params[userType] = attributeHash;
		
			patchUserF(user.id, params, $wr.apiHandler((response) => {
				this.setState({ loading: false });
				if (response[userType].errors) {
					this.toggleEdit(attribute);
					window.wrNotifications.triggerDropDownNotification({
						title: "Sorry!", text: response[userType].errors.join(", "), 
						icon: "exclamation-sign", type: "error" });
				} else {
					setTimeout(function() {
						window.wrNotifications.triggerDropDownNotification({
							title: "Information Edited", icon: "ok-sign" });
						}.bind(this), 1000);
					this.fetchUserDetails();
				}
			}));
		}
	}

	resetOwlshop(e) {
		$wr.nope(e)
		
		var confirmMessage = 'The student\'s avatar, coins, tier, furniture, and perks will be reset. Do you want to continue?'
		if (confirm(confirmMessage)) {
			this.setState({ editedInformation: { reset_owlshop: true }}, () => {
				this.submitEditedInformation('reset_owlshop');
			});
		}
	}

	registerConsultation(feature) {
		var eventText = feature + "-trial-consultation";
		console.log(eventText);
		CustomerIOClient.event(this.state.user, eventText);
		window.wrNotifications.triggerDropDownNotification({
			title: "Consultation Registered", icon: "ok-sign" });
	}

	renderUserDetails(user) {
		var route = "/users/" + user.id + "/details";
		return (
			<Link to={ route }>
				{ user.first_name } { user.last_name } (ID: { user.id })
			</Link>
		);
	}
	renderEntityDetails(entity) {
		if (entity) {
			return (
				<span>
					{entity.name} (ID: {entity.id})
				</span>
			);
		}
	}

	renderEditableField(attribute, inputType) {
		var displayedAttribute = this.state.editedInformation[attribute] || this.state.user[attribute];

		if (inputType === 'date' && displayedAttribute) {
			displayedAttribute = moment(displayedAttribute).format('M/DD/YY')
		}
		if (this.state.editingFields[attribute]) {
			return (
				<td>
					<input type={inputType} defaultValue={ displayedAttribute }
						onKeyDown={ this.onEditKeyPress.bind(this, attribute) }
						onChange={ this.updateEditedInformation.bind(this, attribute) }
						className="form-control editableField" />
				</td>
			);
		} else {
			var editIcon = (<Glyphicon icon="pencil" className="editIcon" />);
			return (
				<td className="editable" onClick={ this.toggleEdit.bind(this, attribute) }>
					<span className="clickableElement">{ displayedAttribute }</span> { editIcon }
				</td>
			);
		}
	}
	// determines weither the attribute exists
	showSetting(user, type, attribute, columnTitle, inputDataType, excludedUsertype) {
		if (user.user_type.localeCompare(excludedUsertype) && user[type]) {
			return this.renderEditableUserSettings(user, type, attribute, columnTitle, inputDataType)
		}
	}
	// renders premium_account and prefs
	renderEditableUserSettings(user, type, attribute, columnTitle, inputDataType) {
		var displayedAttribute = user[type][attribute] ? user[type][attribute] : ''

		if (inputDataType === 'date' && displayedAttribute) {
			displayedAttribute = moment(displayedAttribute).add(1, 'days').format('M/DD/YY')
		}
		if (this.state.editingFields[type] && this.state.editingFields[type][attribute]) {
			var cellContent = (
				<td>
					<input type={inputDataType} defaultValue={displayedAttribute}
						onKeyDown={this.onEditKeyPress.bind(this, attribute)}
						onChange={this.updateEditedPrefsInformation.bind(this, attribute, type)}
						className="form-control editableField" />
				</td>
			);
		} else {
			var editIcon = (<Glyphicon icon="pencil" className="editIcon" />);
			var cellContent = (
				<td className="editable" onClick={this.toggleEdit.bind(this, attribute)}>
					<span className="clickableElement">{displayedAttribute}</span> {editIcon}
				</td>
			);
		}

		return (
			<tr>
				<td>{columnTitle}</td>
				{cellContent}
			</tr>
		)
	}

	renderSchoolOrgAction() {
		var attribute = "add_to_school_org_id";
		if (this.state.editingFields[attribute]) {
			return (
				<div className="schoolOrgAction">
					School Org ID:
					<input type="text" className="form-control schoolOrgField"
						onChange={ this.updateEditedInformation.bind(this, attribute) } />
					<button className="btn buttonSuccess schoolOrgSubmit"
						onClick={ this.submitAndToggle.bind(this, attribute) }>
						Add
					</button>
				</div>
			);
		} else {
			return (
				<div className="schoolOrgAction">
					<button className="btn buttonPrimary" onClick={ this.toggleEdit.bind(this, attribute) }>
						Add to WRS Account
					</button>
				</div>
			);
		}
	}

	updateStudentListStatus(studentListID, studentListData) {
		this.setState({ loading: true });

		var userID = this.props.match.params.id;
		var params = { student_list: studentListData, effective_user_id: userID }
		CurrentUser.api().patchStudentList(studentListID, params, $wr.apiHandler((response) => {
			this.setState({ loading: false });
			if (response.student_list.errors) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Sorry!", text: response.student_list.errors.join(", "), 
					icon: "exclamation-sign", type: "error" });
			} else {
				window.wrNotifications.triggerDropDownNotification({
					title: "Success!", text: "It worked like magic.", icon: "ok-sign" });

				this.fetchUserDetails();
			}
		}));
	}

	makePrimaryList(studentList) {
		if (studentList && studentList.students) {
			this.setState({ loading: true });
			var apiErrors = 0;
			var studentCount = 0;
			_.each(studentList.students, (student) => {
				var params = { student_list_id: studentList.id, student_id: student.id, list_action: 'primary' }
				CurrentUser.api().patchStudent(student.id, params, $wr.apiHandler((response) => {
					studentCount += 1;
					if (response.student.errors) {
						apiErrors += 1;
					}
					this.displayPrimaryListBanner(studentCount, _.size(studentList.students), apiErrors)
				}));
			})
		}
	}

	displayPrimaryListBanner(studentCount, studentListStudentsCount, apiErrors) {
		if (studentCount === studentListStudentsCount) {
			this.setState({ loading: false });
			if (apiErrors) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Sorry!", text: response[userType].errors.join(", "),
					icon: "exclamation-sign", type: "error"
				});
			} else {
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", icon: "ok-sign"
				});
			}
		}
	}

	renderLoadArchivedListStudentsButton() {
		if (!this.state.showArchiveListStudents) {
			return (
				<button className="btn buttonPrimary" onClick={this.loadArchivedListStudents.bind(this)}>Show Students in Archived Lists</button>
			)
		} else {
			return null;
		}
	}

	loadArchivedListStudents() {
		this.setState({ showArchiveListStudents: true });
		this.reloadUser();
	}

	renderArchivedAt(studentList) {
		if (studentList.archived_at) {
			return (<div>Archived at: {new Date(studentList.archived_at).toLocaleDateString("en-US")}</div>)
		}
		return '';
	}

	handleStudentListActions(studentList, user, action) {
		var params = { student_list_id: studentList.id, student_id: user.id, list_action: action }
		CurrentUser.api().patchStudent(user.id, params, $wr.apiHandler((response) => {
			var apiErrors = response.student.errors ? 1 : 0;
			this.displayPrimaryListBanner(1, 1, apiErrors)
			this.fetchUserDetails();
		}));
	}

	renderAssociatedStudentLists() {
		var user = this.state.user;
		if (user.is_student && user.student_lists) {
			var studentListDisplay = _.map(user.student_lists, (studentList) => {
				return (
					<li key={studentList.id}>
						<span>{studentList.name} (ID: {studentList.id})</span>
						<button className="btn buttonPrimary studentListControl noClickStyling" onClick={this.handleStudentListActions.bind(this, studentList, user, 'primary')}>Make Primary List</button>
						<button className="btn buttonPrimary studentListControl noClickStyling" onClick={this.handleStudentListActions.bind(this, studentList, user, 'remove')}>Remove from List</button>
					</li>
				)
			})

			return (
				<tr>
					<td>Associated Student Lists</td>
					<td>
						<ul className='no-bullets'>
							{studentListDisplay}
						</ul>
					</td>
				</tr>
			)
		}
	}

	renderAllStudentListsAndSuspendedBtn() {
		var user = this.state.user;
		var allStudentListDisplay = ''
		if (user.is_student && user.school) {
			var userStudentListIDs = _.pluck(user.student_lists, 'id');
			var activeStudentLists = _.filter(user.school.student_lists, (list) => {
				return list.inactive !== true && !_.contains(userStudentListIDs, list.id)
			})
			if (_.size(activeStudentLists)) {
				var studentListDisplay = _.map(activeStudentLists, (studentList) => {
					return (
						<li key={studentList.id}>
							<span>{studentList.name} (ID: {studentList.id})</span>
							<button className="btn buttonPrimary studentListControl noClickStyling" onClick={this.handleStudentListActions.bind(this, studentList, user, 'add')}>Add to List</button>
						</li>
					)
				})

			allStudentListDisplay = (
				<tr key={user.id + '_studentLists'}>
					<td>All Student Lists</td>
					<td>
						<ul className='no-bullets'>
							{studentListDisplay}
						</ul>
					</td>
				</tr>
				)
			}
		}

		var suspendedRow = ''
		if (user.is_student) {
			var text = this.state.user.suspended ? 'Suspended' : 'Not Suspended'
			suspendedRow = (<tr key={user.id + '_suspended'}>
				<td>Suspended</td>
				<td>{text} {this.renderSuspendButton()}</td>
			</tr>)
		}

		var returnDisplay = _.compact([allStudentListDisplay, suspendedRow])
		return returnDisplay;
	}

	renderAssociatedUserDisplay() {
		var user = this.state.user;

		if (user.is_admin) {
			if (user.role == "teacherRole") {
				var sortedStudentLists = _.sortBy(user.all_student_lists, "inactive");
				var studentListsDisplay = _.map(sortedStudentLists, (studentList) => {
					var studentsDisplay = _.map(studentList.students, (student) => {
						return (
							<li key={ student.id }>
								{ this.renderUserDetails(student) }
							</li>
						);
					});

					if (studentList.inactive) {
						var listClassName = "archivedStudentList";
						var studentListData = { inactive: null };
						var studentListActionButton = (
							<span>
								<button className="btn buttonPrimary btnMarginLeft" onClick={ this.updateStudentListStatus.bind(this, studentList.id, studentListData) }>Unarchive</button>
								<div>{this.renderArchivedAt(studentList)}</div>
							</span>
						)
					} else {
						var studentListData = { inactive: true }
						var studentListActionButton = (
							<span>
								<button className="btn buttonPrimary btnMarginLeft" onClick={this.updateStudentListStatus.bind(this, studentList.id, studentListData)}>Archive</button>
								<LoadingButton className="btn buttonPrimary noClickStyling btnMarginLeft" onClick={this.makePrimaryList.bind(this, studentList)} loading={this.state.loading} text="Make Primary List" />
							</span>
						)
					}

					return (
						<div key={ studentList.id } className={ "studentListInfo " + listClassName }>
							Student List: { this.renderEntityDetails(studentList) } { studentListActionButton }
							<ul>{ studentsDisplay }</ul>
						</div>
					);
				});
			} else if (user.role == "adminRole") {
				var sortedStudentLists = _.sortBy(user.all_school_student_lists, "inactive");
				var studentListsDisplay = _.map(sortedStudentLists, (studentList) => {
					if (studentList.inactive) {
						var listClassName = "archivedStudentList";
					}

					// to protect in case the primary_admin is null, which shouldn't happen but has...
					if (_.includes(this.state.adminsLoading, studentList.primary_admin_id)) { 
						var primaryAdminDisplay = "LOADING...";
					}
					else if (studentList && studentList.primary_admin) {
						var primaryAdminDisplay = this.renderUserDetails(studentList.primary_admin);
					} else {
						var primaryAdminDisplay = "NO PRIMARY ADMIN! BAD!";
					}

					return (
						<div key={ studentList.id } className={ listClassName }>
							{ this.renderEntityDetails(studentList) }, Admin: { primaryAdminDisplay }
						</div>
					);
				});
			}
			if (_.size(sortedStudentLists)) {
				return (
					<tr>
						<td>Associated</td>
						<td>
							{studentListsDisplay}
							<div className='load-archived-button'>{this.renderLoadArchivedListStudentsButton()}</div>
						</td>
					</tr>
				);
			}
		} else if (user.is_student && user.primary_student_list) {
			return (
				<tr>
					<td>Primary Admin</td>
					<td>{ this.renderUserDetails(user.primary_student_list.primary_admin) }</td>
				</tr>
			);
		}
	}

	openAddStudentModal(e) {
		$wr.nope(e)
		this.refs.addStudentModal.show();
	}

	openaddClassModal(e) {
		$wr.nope(e)
		this.refs.newClassModal.show();
	}

	attemptDestroyTeacher() {
		if (confirm("Are you sure? This will delete the teacher, classes, and student information.")) {
			CurrentUser.api().deleteAdmin(this.state.user.id, () => {
				window.wrNotifications.triggerDropDownNotification({
					title: "Bye Bird!", text: "Teacher account has been deleted", icon: "certificate" });
				$wr.redirect("/");
			})
		}
	}

	attemptDowngradeTeacher(user) {
		if (confirm("Are you sure? This will downgrade the teacher and delete the associated deal")) {
			var params = { premium_account_id: user.premium_account.id, effective_user_id: user.id, teacher_action: 'downgrade' }
			CurrentUser.api().patchAdmin(this.state.user.id, params, $wr.apiHandler((response) => {
				if (response.error) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Sorry!", text: response.error, icon: "exclamation-sign", type: "error"
					});
				} else {
					window.wrNotifications.triggerDropDownNotification({
						title: "Done!", text: "Teacher account has been downgraded", icon: "certificate"
					});
				}
			}))
		}
	}

	attemptCIORemoval(user) {
		if (confirm("Are you sure? This will remove the teacher from CIO until they log in again")) {
			var params = { effective_user_id: user.id, teacher_action: 'cio_removal' }
			CurrentUser.api().patchAdmin(this.state.user.id, params, $wr.apiHandler((response) => {
				if (response.error) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Sorry!", text: response.error, icon: "exclamation-sign", type: "error"
					});
				} else {
					window.wrNotifications.triggerDropDownNotification({
						title: "Done!", text: "Teacher account has been removed from CIO", icon: "certificate"
					});
				}
			}))
		}
	}

	renderSuspendButton() {
		if (this.state.user.suspended) {
			return <button className="btn buttonPrimary noClickStyling" onClick={ this.suspendHandler.bind(this, false) }>Unsuspend</button>
		} else {
			return <button className="btn buttonPrimary noClickStyling" onClick={ this.suspendHandler.bind(this, true) }>Suspend</button>
		}
	}

	renderDowngradeButton() {
		var { user } = this.state;
		if (user && user.premium_account) {
			return <button className="btn btn-danger" onClick={this.attemptDowngradeTeacher.bind(this, user)}>Downgrade</button>
		}
	}

	renderCIORemoval() {
		var { user } = this.state;
		return <button className="btn btn-danger" onClick={this.attemptCIORemoval.bind(this, user)}>Remove from CIO</button>
	}

	suspendHandler(value) {
		if (this.state.editedInformation['suspended']) {
			var stateCopy = { ...this.state.editedInformation };
			stateCopy['suspended'] = value;
			this.setState({ editedInformation: stateCopy }, () => this.submitEditedInformation('suspended'))
		} else {
			this.setState({ editedInformation: { ...this.state.editedInformation, suspended: value } }, () => this.submitEditedInformation('suspended'));
		}
	}

	render() {
		var headerDisplay = (
			<div className="headerSection">
				<header className="pageHeader">
					<h1>Power Drill</h1>
				</header>
			</div>
		);

		var user = this.state.user;

		if (user == null) {
			var userDetailsDisplay = (
				<Spinner placeholder={ true } scale={ 1.7 } />
			);
		} else {
			var ssoDataDisplay = _.map(_.keys(user.sso_data), (key) => {
				return (
					<tr key={ key }>
						<td>SSO Data ({ key })</td>
						<td>{ user.sso_data[key] + "" }</td>
					</tr>
				);
			});
			if (user.account) {
				var activeTrialDisplay = _.map(_.keys(user.account.active_trials), (key) => {
					return (
						<tr key={ key }>
							<td>Trial ({ key })</td>
							<td>{ user.account.active_trials[key] + "" + " (expiration)"}</td>
						</tr>
					);
				});
				var expiredTrialDisplay = _.map(_.keys(user.account.expired_trials), (key) => {
					return (
						<tr key={ key }>
							<td>Epired Trial ({ key })</td>
							<td>{ user.account.expired_trials[key] + "" }</td>
						</tr>
					);
				});
				// var trialPath = "/users/" + user.id + "/trigger?what=trial&features=wrSilver&days=30";
				// var trialURL = WhooosReadingServices.ApiServer.url(trialPath);
				// var extendTrialLink = (
				// 	<tr>
				// 		<td>Extend Trial</td>
				// 		<td><a className = "btn buttonPrimary" href={ trialURL }>Extend Trial</a></td>
				// 	</tr>
				// )	
			}

			// admin only displays
			if (user.is_admin) {

				if (user.demo) {
					var demoExpirationDisplay = (
						<tr>
							<td>Demo Expiration</td>
							{this.renderEditableField("demo_expiration_date", 'date')}
						</tr>
					)
				}

				var emailDisplay = (
					<tr>
						<td>Email</td>
						{ this.renderEditableField("email") }
					</tr>
				);
				var signInEmailDisplay = (
					<tr>
						<td>Sign In Email</td>
						{ this.renderEditableField("sign_in_email") }
					</tr>
				);

				if (user.role == "teacherRole") {
					if (user.school && !user.primary_school_org) {
						var addToSchoolOrg = this.renderSchoolOrgAction();
					}

					var activeStudentLists = _.reject(user.all_student_lists, { inactive: true });
					var addStudentModal = (
						<AddNewStudentModal ref="addStudentModal" onAddedStudents={ this.reloadUser }
							studentLists={ activeStudentLists } effectiveUserID={ user.id } />
					);
					var addClassModal = (
						<AddNewClassModal ref="newClassModal" studentLists={ activeStudentLists }
							effectiveUserID={ user.id } addStudentLists={ this.reloadUser } />
					)
					var adminActionsDisplay = (
						<tr>
							<td>Actions</td>
							<td>
								<div className="btn-group">
									<button className="btn buttonPrimary" onClick={ this.openAddStudentModal }>Add Students</button>
									<button className="btn buttonPrimary" onClick={ this.openaddClassModal }>Add Classes</button>
									{this.renderSuspendButton()}
								</div><br/>
								<div className="btn-group">
									{this.renderDowngradeButton()}
									{this.renderCIORemoval()}
									<button className="btn btn-danger" onClick={this.attemptDestroyTeacher}>Delete</button>
								</div>
								{/* <p>Register Consultation:</p>
								<div className="btn-group">
									<LoadingButton className="btn buttonPrimary"
										onClick={ this.triggerUserAction.bind(this, "release_reading_levels") }
										loading={ this.state.loading } text="RLDs" />
									<button className="btn buttonPrimary"
										onClick={ this.registerConsultation.bind(this, "autograder-data") }>
										Details & Comments
									</button>
									<button className="btn buttonPrimary"
										onClick={ this.registerConsultation.bind(this, "log-reading") }>
										Log Reading
									</button>
									<button className="btn buttonPrimary"
										onClick={ this.registerConsultation.bind(this, "digital-exercises") }>
										Insights
									</button>
								</div> */}
								{ addToSchoolOrg }
							</td>
						</tr>
					);

					var studentIDs = _.flatten(_.map(activeStudentLists, (studentList) => {
						return _.pluck(studentList.students, "id")
					}))
					var viewAllPath = "/logins/cards?student_ids=" + studentIDs.join(",");
					var allLoginsLink = (
						<tr>
							<td>Logins</td>
							<td>
								<a href="#" onClick={ DocumentClient.buildOpenF(viewAllPath, user.id) }
									className="printLink"> 

									Print login information
								</a>

							</td>
						</tr>

					)
					var upgradeLinksDisplay = (
						<tr>
							<td>Trials</td>
							<td>
								<div className="trialContainer">
									<p className="">WR Gold</p>
									<input type="text" className="form-control" ref="wrGold" />
									<button className="btn buttonPrimary" onClick={ this.submitExtensionRequest.bind(this, "wrGold") }>Submit</button>
								</div>
								<div className="trialContainer">
									<p className="">WR Silver</p>
									<input type="text" className="form-control" ref="wrSilver" />
									<button className="btn buttonPrimary" onClick={ this.submitExtensionRequest.bind(this, "wrSilver") }>Submit</button>
								</div>
								<div className="trialContainer">
									<p className="">RLD</p>
									<input type="text" className="form-control" ref="cloze-assessments" />
									<button className="btn buttonPrimary" onClick={ this.submitExtensionRequest.bind(this, "cloze-assessments") }>Submit</button>
								</div>
							</td>
						</tr>	
					)
				}
			}

			// student only displays
			if (user.is_student) {
				var academicLevelDisplay = (
					<tr>
						<td>Academic Level</td>
						<td>{ user.prefs.academic_level }</td>
					</tr>
				);

				var primaryStudentListDisplay = (
					<tr>
						<td>Primary Student List</td>
						<td>{ this.renderEntityDetails(user.primary_student_list) }</td>
					</tr>
				);

				var owlshopActions = (
				<tr>
					<td>
						Owlshop Actions
					</td>
					<td>
						<div className="btn-group">
							<button className="btn buttonPrimary"
								onClick={ this.resetOwlshop }>
								Reset Owlshop
							</button>
						</div>
					</td>
				</tr>
				)
			}

			if (user.school) {
				if (user.primary_school_org) {
					var schoolOrgID = user.primary_school_org.id;
					var route = "/school_orgs/" + schoolOrgID + "/details";
					var schoolOrgDisplay = (
						<div>
							<Link to={ route }>
								School Org ID: { schoolOrgID }
							</Link>
						</div>
					);
				}

				if (user.school.canonical_id) {
					var canonicalID = user.school.canonical_id;
					var url = WhooosReadingServices.CanonicalSchools.browseUrl("/schools/" + canonicalID);
					var canonicalSchoolDisplay = (
						<div>
							<a href={ url } target="_blank">
								Canonical ID: { user.school.canonical_id }
							</a>
						</div>
					);
				}
				var schoolDisplay = (
					<tr>
						<td>School</td>
						<td>
							<div>{ this.renderEntityDetails(user.school) }</div>
							{ canonicalSchoolDisplay }
							{ schoolOrgDisplay }
						</td>
					</tr>
				);
			}


			var userDetailsDisplay = (
				<table>
					<tbody>
						<tr>
							<td>User</td>
							<td>{ this.renderUserDetails(user) }</td>
						</tr>
						{ emailDisplay }
						{ signInEmailDisplay }
						<tr>
							<td>Username</td>
							{ this.renderEditableField("username", 'text') }
						</tr>
						<tr>
							<td>Password</td>
							{ this.renderEditableField("password", 'text') }
						</tr>
						{ ssoDataDisplay }
						<tr>
							<td>Google ID</td>
							{this.renderEditableField("google_id", 'text')}
						</tr>
						<tr>
							<td>Clever ID</td>
							{this.renderEditableField("clever_id", 'text')}
						</tr>
						<tr>
							<td>Role</td>
							<td>{ user.role }</td>
						</tr>
						<tr>
							<td>Product</td>
							<td>{ user.product }</td>
						</tr>
						<tr>
							<td>Grade Level</td>
							<td>{ user.grade_level }</td>
						</tr>
						{academicLevelDisplay}						
						{this.showSetting(user, "prefs", MAX_STUDENT_OVERRIDE, 'Max Students Per Class', 'number', null)}						
						{this.showSetting(user, "prefs", MAX_STUDENT_LIST_OVERRIDE, 'Max Classes', 'number', null)}					
						{this.showSetting(user, 'premium_account', STUDENT_LIST_COUNT, 'Max Classes on Premium', 'number', null)}
						{this.showSetting(user, 'premium_account', NEXT_CHARGE, 'License End Date', 'date', "Student")}
						{demoExpirationDisplay}
						<tr>
							<td>Created At</td>
							<td>{ moment(user.created_at).format('M/DD/YY') }</td>
						</tr>
						<tr>
							<td>Last Active</td>
							<td>{ moment(user.last_active).format('M/DD/YY') }</td>
						</tr>
						{ schoolDisplay }
						{primaryStudentListDisplay}
						{this.renderAssociatedStudentLists()}
						{this.renderAllStudentListsAndSuspendedBtn()}
						{this.renderAssociatedUserDisplay()}
						{ allLoginsLink }
						{ adminActionsDisplay }
						{ activeTrialDisplay }
						{ expiredTrialDisplay }
						{ upgradeLinksDisplay }
						{ owlshopActions }
					</tbody>
				</table>
			);
		}

		return (
			<div className="userDetailsPage container">
				{ headerDisplay }
				{ userDetailsDisplay }
				{ addStudentModal }
				{ addClassModal }
			</div>
		);
	}

	reloadUser() {
		// Timeout to allow modals to close
		setTimeout(() => {
			this.setState({ user: null }, this.fetchUserDetails);
		}, 50)
	}
	fetchUserDetails() {
		var userID = this.props.match.params.id;

		// reset only if it's a new user
		if (this.state.user && userID != this.state.user.id) {
			this.setState({ user: null });
		}

		CurrentUser.api().getUser(userID, { effective_user_id: userID }, $wr.apiHandler((response) => {
			var tmpUser = response.user;

			var embeds = "user.school,user.primary_school_org,user.sso_data,user.email,user.sign_in_email,user.password";

			if (tmpUser.role == "teacherRole") {
				if (this.state.showArchiveListStudents) {
					embeds += ",admin.all_student_lists,student_list.students,student_list.inactive,user.account,user.prefs";
				} else {
					embeds += ",admin.all_student_lists,student_list.active_students,student_list.students,student_list.inactive,user.account,user.prefs,user.premium_account";
				}

			} else if (tmpUser.role == "adminRole") {
				embeds += ",admin.all_school_student_lists,student_list.primary_admin_id,student_list.inactive,user.prefs,user.premium_account";

			} else if (tmpUser.role == "studentRole") {
				embeds += ",student.prefs,student.primary_student_list,student_list.primary_admin,student.student_lists,school.student_lists";
			}

			CurrentUser.api().getUser(userID, { embed: embeds, effective_user_id: userID }, $wr.apiHandler((response) => {
				this.setState({ user: response.user }, this.fetchPrimaryAdmins(response.user, embeds));				
			}));

		}));
	}

	fetchPrimaryAdmins(user, embeds) {
		if (!user.all_school_student_lists || user.role != "adminRole") return;

		var primaryAdminIDs = _.uniq(_.compact(_.pluck(user.all_school_student_lists, 'primary_admin_id')));
		this.setState({ adminsLoading: primaryAdminIDs });

		primaryAdminIDs.forEach(userID => {
			CurrentUser.api().getUser(userID, { embed: embeds, effective_user_id: userID }, $wr.apiHandler(response => {
				_.where(user.all_school_student_lists, { primary_admin_id: userID }).forEach(sl => sl.primary_admin = response.user);
				this.setState({
					user: user,
					adminsLoading: _.filter(this.state.adminsLoading, aID => aID !== userID)
				});
			}));
		});
	}

	componentDidUpdate(prevProps) {
		if ($wr.didParamsChange(prevProps, this.props)) {
			this.fetchUserDetails();
		}
	}
	componentDidMount() {
		this.fetchUserDetails();
	}
};

const MAX_STUDENT_OVERRIDE = 'max_students_count_override'
const MAX_STUDENT_LIST_OVERRIDE = 'max_student_list_count_override'
const PREF_ATTRIBUTES = [MAX_STUDENT_OVERRIDE, MAX_STUDENT_LIST_OVERRIDE]

const STUDENT_LIST_COUNT = 'student_list_count'
const NEXT_CHARGE = 'next_charge'
const PREMIUM_ACCOUNT_ATTRIBUTES = [STUDENT_LIST_COUNT, NEXT_CHARGE]

UserDetailsPage.propTypes = PageStrictPropTypes({
});

module.exports = UserDetailsPage;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/UserDetailsPage.js